module.exports = __webpack_public_path__ + "img/fangxun-1.d81aa321.png";